import { getAnalytics, logEvent, setUserProperties, type Analytics } from 'firebase/analytics'
import { isSupported } from 'firebase/analytics'

import { firebaseApp } from './firebase'

/**
 * Kullanım ölçümü.
 *
 * NE GÖNDERİLİR: hangi ekranın açıldığı, hangi eylemin yapıldığı, kaç
 * kalem olduğu gibi SAYIMLAR.
 *
 * NE GÖNDERİLMEZ — ve bu bir tercih değil, kural: tutarlar, hesap
 * adları, işyeri adları, kategori adları, not metinleri, e-posta, kredi
 * koşulları. Kullanıcı buraya banka hareketlerini giriyor; bir analitik
 * sağlayıcısına "Migros'ta 745 TL harcandı" göndermek, ürünün var oluş
 * sebebine aykırı.
 *
 * Kural aşağıdaki `track` imzasıyla ZORLANMIYOR (TypeScript bunu
 * yapamaz) ama parametreler süzülüyor: yalnızca sayı ve bilinen kısa
 * etiketler geçiyor, serbest metin düşürülüyor. Kod incelemesinde
 * gözden kaçan bir alan sessizce dışarı sızmasın.
 */
let analytics: Analytics | null = null
let ready = false

export async function initAnalytics(): Promise<void> {
  if (ready) return
  ready = true
  try {
    if (!(await isSupported())) return
    analytics = getAnalytics(firebaseApp())
  } catch (error) {
    console.warn('Analitik başlatılamadı:', error)
  }
}

/** İzin verilen parametre değeri: sayı, bool ya da KISA etiket. */
type Param = number | boolean | string

/**
 * Serbest metni eler.
 *
 * Uzun ya da boşluk içeren dizeler DÜŞÜRÜLÜYOR: bir işyeri adı, hesap
 * adı ya da not buradan geçebilecek tek şekil bu. Kısa ve boşluksuz
 * etiketler ("credit_card", "monthly") geçiyor.
 */
function safe(params: Record<string, Param>): Record<string, Param> {
  const out: Record<string, Param> = {}
  for (const [key, value] of Object.entries(params)) {
    if (typeof value === 'number' || typeof value === 'boolean') {
      out[key] = value
      continue
    }
    if (typeof value === 'string' && value.length <= 32 && !/\s/.test(value)) {
      out[key] = value
    }
  }
  return out
}

export function track(event: string, params: Record<string, Param> = {}): void {
  if (!analytics) return
  try {
    logEvent(analytics, event, safe(params))
  } catch {
    // Ölçüm, ürünün çalışmasını etkilemez.
  }
}

/**
 * Kullanıcı özellikleri — KİMLİK DEĞİL.
 *
 * Firebase'in setUserId'si BİLEREK kullanılmıyor: kullanıcıyı analitik
 * sağlayıcısında tekil olarak izlenebilir yapmak, finansal davranışı bir
 * kimliğe bağlamak demek. Buraya yalnızca kümeleyen özellikler giriyor
 * (dil, tema, hane para birimi) — hangi kullanıcı olduğu değil.
 */
export function setAudience(props: Record<string, Param>): void {
  if (!analytics) return
  try {
    setUserProperties(analytics, safe(props))
  } catch {
    /* yok sayılıyor */
  }
}
